<template>
  <div id="agent-avatar">
    <div class="agent-avatar-image">
      <v-img
        :src="img"
        alt="John"
      ></v-img>
    </div>
    <div class="agent-avatar-state-icon">
      <Icon
        :size="21"
        :color="'green'"
        icon="circle-filled"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    img: {
      default: 'https://hips.hearstapps.com/hmg-prod/images/avatar-2-1583234102.jpg',
    },
  }
})
export default class BotAvatar extends Vue {}
</script>

<style>
#agent-avatar {
  position: relative;
  width: 60px;
  height: 60px;
}

#agent-avatar .agent-avatar-image {
  position: absolute;
  width: 100%;
  height: 100%;
}

#agent-avatar .agent-avatar-image .v-image__image {
  border-radius: 50%;
  width: 100%;
  height: 100%;
}

#agent-avatar .agent-avatar-state-icon {
  position: absolute;
  right: 2px;
  bottom: 2px;
  background-color: rgb(255, 255, 255);
  width: 14px;
  height: 14px;
  border-radius: 50%;
}
</style>
